const steps = [
  'Sobre o Dispositivo',
  'Endereço de Entrega',
  'Ordem de Serviço',
];

export default steps;
